export class ContactRequestSource {

    constructor(
        public id: number,
        public name: string,
        public leadLabel: string,
        public description?: string
    ){}
}
